var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoard = function SvgBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H2v10.99h10V3h-1a1.999 1.999 0 0 1-2 1.998H5c-1.104 0-2-.893-2-1.999Zm8-2h2a1 1 0 0 1 1 1v11.992c0 1.105-.895 1.999-2 1.999H2c-1.105 0-2-.894-2-2V2a1 1 0 0 1 1-1h2A1 1 0 0 1 4 0h6a1 1 0 0 1 1 1ZM5 2h4v.998H5V2ZM3 7.997a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1Zm5-1a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H8Zm0 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H8Zm-4 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H4Z"
  })));
};
export default SvgBoard;